import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  return <>
      <footer className="w-full bg-lime-50 py-8 border-t border-lime-200" data-id="element-1">
        <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-2">
          <div className="flex items-center justify-center gap-6 text-sm text-gray-600" data-id="element-3">
            <button onClick={() => setPrivacyModalOpen(true)} className="underline hover:text-gray-900 transition-colors" data-id="element-4">
              Privacy Policy
            </button>
            <span className="text-gray-400" data-id="element-5">•</span>
            <button onClick={() => setTermsModalOpen(true)} className="underline hover:text-gray-900 transition-colors" data-id="element-6">
              Terms of Service
            </button>
          </div>
          <p className="mt-4 text-xs text-gray-500" data-id="element-7">
            © {new Date().getFullYear()} Cena Sin Pensar. All rights reserved.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyModalOpen} onClose={() => setPrivacyModalOpen(false)} title="Privacy Policy" data-id="element-8">
        <div className="prose prose-sm max-w-none space-y-6 text-gray-700" data-id="element-9">
          <p className="text-sm text-gray-500" data-id="element-10">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section data-id="element-11">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-12">
              1. Information We Collect
            </h3>
            <p data-id="element-13">
              We collect information you provide directly to us when you
              purchase our product, including your name, email address, and
              payment information. We use secure third-party payment processors
              to handle all payment transactions.
            </p>
          </section>

          <section data-id="element-14">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-15">
              2. How We Use Your Information
            </h3>
            <p data-id="element-16">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-17">
              <li data-id="element-18">Process your orders and deliver the product</li>
              <li data-id="element-19">Send you order confirmations and updates</li>
              <li data-id="element-20">Respond to your questions and provide customer support</li>
              <li data-id="element-21">Improve our products and services</li>
            </ul>
          </section>

          <section data-id="element-22">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-23">
              3. Information Sharing
            </h3>
            <p data-id="element-24">
              We do not sell, trade, or rent your personal information to third
              parties. We may share your information with trusted service
              providers who assist us in operating our website and conducting
              our business, as long as they agree to keep this information
              confidential.
            </p>
          </section>

          <section data-id="element-25">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-26">
              4. Cookies and Tracking
            </h3>
            <p data-id="element-27">
              We use cookies and similar tracking technologies to improve your
              browsing experience, analyze site traffic, and understand where
              our visitors are coming from. You can control cookies through your
              browser settings.
            </p>
          </section>

          <section data-id="element-28">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-29">
              5. Data Security
            </h3>
            <p data-id="element-30">
              We implement appropriate security measures to protect your
              personal information. However, no method of transmission over the
              internet is 100% secure, and we cannot guarantee absolute
              security.
            </p>
          </section>

          <section data-id="element-31">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-32">
              6. Your Rights
            </h3>
            <p data-id="element-33">
              You have the right to access, correct, or delete your personal
              information. You may also opt out of receiving marketing
              communications from us at any time.
            </p>
          </section>

          <section data-id="element-34">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-35">
              7. Contact Us
            </h3>
            <p data-id="element-36">
              If you have any questions about this Privacy Policy, please
              contact us at privacy@cenasinpensar.com
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={termsModalOpen} onClose={() => setTermsModalOpen(false)} title="Terms of Service" data-id="element-37">
        <div className="prose prose-sm max-w-none space-y-6 text-gray-700" data-id="element-38">
          <p className="text-sm text-gray-500" data-id="element-39">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section data-id="element-40">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-41">
              1. Acceptance of Terms
            </h3>
            <p data-id="element-42">
              By accessing and using this website and purchasing our product,
              you accept and agree to be bound by these Terms of Service. If you
              do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section data-id="element-43">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-44">
              2. Product Description
            </h3>
            <p data-id="element-45">
              "Cena Sin Pensar" is a digital meal planning system delivered as a
              downloadable PDF. The product is designed to help you simplify
              dinner decision-making through a structured system.
            </p>
          </section>

          <section data-id="element-46">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-47">
              3. Purchase and Payment
            </h3>
            <p data-id="element-48">
              All purchases are final. Upon successful payment, you will receive
              immediate access to download the product. Prices are subject to
              change without notice, but changes will not affect orders already
              placed.
            </p>
          </section>

          <section data-id="element-49">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-50">
              4. License and Usage
            </h3>
            <p data-id="element-51">
              Upon purchase, you are granted a personal, non-transferable
              license to use the product for your own personal use. You may not:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-52">
              <li data-id="element-53">Resell, redistribute, or share the product with others</li>
              <li data-id="element-54">Modify or create derivative works based on the product</li>
              <li data-id="element-55">Use the product for commercial purposes</li>
            </ul>
          </section>

          <section data-id="element-56">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-57">
              5. Refund Policy
            </h3>
            <p data-id="element-58">
              Due to the digital nature of our product, all sales are final.
              However, if you experience technical issues accessing your
              purchase, please contact us at support@cenasinpensar.com and we
              will work to resolve the issue.
            </p>
          </section>

          <section data-id="element-59">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-60">
              6. Disclaimer of Warranties
            </h3>
            <p data-id="element-61">
              The product is provided "as is" without warranties of any kind,
              either express or implied. We do not guarantee that the product
              will meet your specific requirements or that it will be
              error-free.
            </p>
          </section>

          <section data-id="element-62">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-63">
              7. Limitation of Liability
            </h3>
            <p data-id="element-64">
              In no event shall we be liable for any indirect, incidental,
              special, or consequential damages arising out of or in connection
              with your use of the product.
            </p>
          </section>

          <section data-id="element-65">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-66">
              8. Changes to Terms
            </h3>
            <p data-id="element-67">
              We reserve the right to modify these terms at any time. Changes
              will be effective immediately upon posting to this website. Your
              continued use of the service after changes constitutes acceptance
              of the modified terms.
            </p>
          </section>

          <section data-id="element-68">
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-69">
              9. Contact Information
            </h3>
            <p data-id="element-70">
              For questions about these Terms of Service, please contact us at
              legal@cenasinpensar.com
            </p>
          </section>
        </div>
      </Modal>
    </>;
}